export default "__VITE_ASSET__95396720__"